import { supabase } from './supabase'

const PAGE_SIZE = 1000

/**
 * Fetches all rows matching an .in() filter, paginating each chunk
 * to bypass the default 1 000-row limit per request.
 *
 * @param table      - Table name
 * @param select     - Columns to select
 * @param inColumn   - Column name for the IN filter
 * @param inValues   - Array of values for the IN filter
 * @param extraFilters - Optional callback to add more filters (eq, gte, etc.)
 */
export async function fetchAllIn<T>(
  table: string,
  select: string,
  inColumn: string,
  inValues: string[],
  extraFilters?: (q: any) => any,
): Promise<T[]> {
  const all: T[] = []
  const chunkSize = 300

  for (let i = 0; i < inValues.length; i += chunkSize) {
    const idChunk = inValues.slice(i, i + chunkSize)
    let from = 0

    while (true) {
      let q = supabase
        .from(table)
        .select(select)
        .in(inColumn, idChunk)
        .range(from, from + PAGE_SIZE - 1)

      if (extraFilters) q = extraFilters(q)

      const { data, error } = await q
      if (error) throw error
      if (!data || data.length === 0) break
      all.push(...(data as T[]))
      if (data.length < PAGE_SIZE) break
      from += PAGE_SIZE
    }
  }

  return all
}

/**
 * Fetches all rows from a table with optional filters, paginating automatically.
 */
export async function fetchAllRows<T>(
  table: string,
  select: string,
  applyFilters?: (q: any) => any,
): Promise<T[]> {
  const all: T[] = []
  let from = 0

  while (true) {
    let q = supabase
      .from(table)
      .select(select)
      .range(from, from + PAGE_SIZE - 1)

    if (applyFilters) q = applyFilters(q)

    const { data, error } = await q
    if (error) throw error
    if (!data || data.length === 0) break
    all.push(...(data as T[]))
    if (data.length < PAGE_SIZE) break
    from += PAGE_SIZE
  }

  return all
}
